export const FORWARD = 1;
export const REVERSE = 2;
export const FORWARD_REVERSE = 3;
export const BROWNIAN = 4;
